export enum AccountState {
  NEVER_LINKED = 'never_linked',
  LOCKED = 'locked',
  LINKING = 'linking',
  VERIFYING_LINK = 'verifying_link',
  LINKED = 'linked',
  LINK_REMOVED = 'link_removed',
}
